import {
    Box,
    Grid,
    Tab
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { LoadingButton, TabContext, TabList, TabPanel } from "@mui/lab";
import { useDispatch, useSelector } from "react-redux";
import { markedAsAccpetManufacturing, markedAsRejectLSM, selectManufactureProductLoading } from "../../../slices/manufacturer";
import { useEffect, useState } from "react";
import FormikControl from "../../../components/common/FormikControl";
import { fetchLSMAcceptanceReasonDropDown, selectBmrbmrLSMAcceptanceReasonsDropDown } from "../../../slices/lsmAcceptanceReason";
import { fetchLSMRejectionReasonDropDown, selectBmrLsmRejectionReasonDropdown } from "../../../slices/lsmRejectionReason";
import { selectCurrentCycle } from "../../../slices/common";

const initialValues = {
    reason_id: "", // default selection
    comment: "",
    cd3_count: ""
};

const validationSchema = Yup.object().shape({
    cd3_count: Yup.string().nullable()
        .required("CD3 count is required")
        .test(
            "max-decimals",
            "At most 2 decimal places are allowed",
            (value) => {
                if (value === undefined || value === null || value === "") return true;
                const parts = value.split('.');
                return parts.length <= 1 || parts[1].length <= 2;
            }
        ),

    reason_id: Yup.string(), // keep optional here
    // Put the cross-field test on `comment` so there's no circular dependency.
    comment: Yup.string().test(
        "reason-or-comment",
        "Either reason or comment is required",
        function (value) {
            const { reason_id } = this.parent || {};
            const hasReason = reason_id !== undefined && String(reason_id).trim() !== "";
            const hasComment = value !== undefined && String(value).trim() !== "";
            if (hasReason || hasComment) return true;

            // Attach the error to `comment` (this.path === "comment")
            return this.createError({
                path: this.path,
                message: "Either reason or comment is required",
            });
        }
    ),
});

const LSMApproval = (
    formProps
) => {
    const [value, setValue] = useState('1');
    const isLoading = useSelector(selectManufactureProductLoading)
    const dispatch = useDispatch();
    const LSMAcceptanceReasonDropDown = useSelector(selectBmrbmrLSMAcceptanceReasonsDropDown)
    const LSMRejectReasonDropDown = useSelector(selectBmrLsmRejectionReasonDropdown)
    // const { id, feasibility_id } = useParams();\\
    const currentCycle = useSelector(selectCurrentCycle)
    
    const getAllDropdown = async () => {
        try {
            await dispatch(fetchLSMAcceptanceReasonDropDown())
            await dispatch(fetchLSMRejectionReasonDropDown())
        } catch (err) {
            console.error(err);

        }
    }

    useEffect(() => {
        getAllDropdown()
    }, []);




    const handleSubmit = async (values) => {
        try {
            // Prepare API payload with the selected restart option
            const payload = {
                data: {
                    ...values,
                    qrCode_id: formProps?.patientDetails
                },
                inbound_patient_id: formProps?.inbound_patient_id,
                feasibility_assessment_id: currentCycle?.feasibility_assessments_id,
                cycle: currentCycle?.cycle
            };

            if (value == 1) {
                const res = await dispatch(markedAsAccpetManufacturing(payload)).unwrap();
                if (res?.status === 200) {
                    formProps?.handleFormSubmit?.();
                    formProps?.handleCryoSubmitTask?.(); 
                }
            } else if (value == 2) {
                const res = await dispatch(markedAsRejectLSM(payload)).unwrap();

                if (res?.status === 200) {
                    formProps.handleFormSubmit();
                }
            }
        } catch (err) {
            console.error("Error LSM Approval:", err);
        }
    };


    const formik = useFormik({
        initialValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit: handleSubmit,
    });

    const handleChange = (event, newValue) => {
        setValue(newValue);
        formik.setFieldValue("reason_id", "")
    };


    const formOptions1 = [
        {
            label: 'Acceptance Reason',
            type: 'select',
            name: 'reason_id',
            required:true,
            placeholder: "Select acceptance reason",
            options: LSMAcceptanceReasonDropDown,
        },
        {
            label: 'CD3 Count',
            type: 'number',
            required:true,
            name: 'cd3_count',
            placeholder: "Enter the CD3 Count",
        },
        {
            label: 'Comment',
            type: 'textarea',
            name: 'comment',
            placeholder: 'Enter Comment',
            required: true,
        },
    ];

    const formOptions2 = [
        {
            label: 'Rejection Reason',
            type: 'select',
            name: 'reason_id',
            placeholder: "Select rejection reason",
            options: LSMRejectReasonDropDown,
        },
        {
            label: 'CD3 Count',
            type: 'number',
            name: 'cd3_count',
            required:true,
            placeholder: "Enter the CD3 Count",
        },
        {
            label: 'Comment',
            type: 'textarea',
            name: 'comment',
            placeholder: 'Enter Comment',
            required: true,
        },
    ];

    const tabs = [
        { id: "1", label: "LSM Approve" },
        { id: "2", label: "LSM Reject" }
    ];

    return (
        <Box>
            <Box sx={{ width: '100%', typography: 'body1' }} className="bg-white rounded-xl">
                <TabContext value={value}>
                    <Box
                    // sx={{ borderBottom: 1, borderColor: '#3571FF' }}
                    >
                        <Box className="bg-[#E8EFFC]">
                            <TabList
                                value={value}
                                onChange={handleChange}
                                variant="scrollable"
                                scrollButtons="auto"
                                aria-label="scrollable auto tabs example"
                                TabIndicatorProps={{ style: { display: "none" } }} // remove default underline
                            >
                                {tabs.map((tab) => (
                                    <Tab
                                        key={tab.id}
                                        value={tab.id}
                                        label={
                                            <div className="flex items-center gap-2">
                                                <span
                                                    className={`${value === tab.id
                                                        ? "text-blue-600 font-semibold"
                                                        : "text-black"
                                                        }`}
                                                >
                                                    {tab.label}
                                                </span>
                                            </div>
                                        }
                                        style={value === tab.id ? {
                                            borderTop: "#3571FF solid 1px",
                                            borderRight: "#3571FF solid 1px",
                                            borderLeft: "#3571FF solid 1px",
                                            backgroundColor: "white"
                                        } : { border: "transparent" }}
                                        className={`normal-case px-4 py-2 rounded-t-lg transition`}
                                    />
                                ))}
                            </TabList>
                        </Box>
                    </Box>
                    <TabPanel value="1">
                        <form onSubmit={formik.handleSubmit}>
                            <Grid container spacing={2} className="mb-3">
                                {formOptions1.map((props, key) => (
                                    <Grid key={key} item xs={12}>
                                        <FormikControl formik={formik} {...props} />
                                    </Grid>
                                ))}
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <LoadingButton
                                        fullWidth
                                        type="submit"
                                        variant="contained"
                                        loading={isLoading}
                                        sx={{ backgroundColor: "#3571FF" }}
                                    >
                                        Approve
                                    </LoadingButton>
                                </Grid>
                            </Grid>
                        </form>
                    </TabPanel>
                    <TabPanel value="2">
                        <form onSubmit={formik.handleSubmit}>
                            <Grid container spacing={2} className="mb-3">
                                {formOptions2.map((props, key) => (
                                    <Grid key={key} item xs={12}>
                                        <FormikControl formik={formik} {...props} />
                                    </Grid>
                                ))}
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <LoadingButton
                                        fullWidth
                                        type="submit"
                                        variant="contained"
                                        loading={isLoading}
                                        sx={{ backgroundColor: "#3571FF" }}
                                    >
                                        Reject
                                    </LoadingButton>
                                </Grid>
                            </Grid>
                        </form>
                    </TabPanel>
                </TabContext>
            </Box>
        </Box>
    );
};

export default LSMApproval;
